import memoize from "lodash/memoize";

export const createHashFromMap = memoize((map: {}): string =>
  createHash(Object.keys(map).join())
);
export const createHash = memoize(
  (s: string): string =>
    s.split("").reduce((a, b) => ((a << 5) - a + b.charCodeAt(0)) | 0, 0) + ""
);
